import { makeStyles } from '@material-ui/core/styles'
const useSignInStyles = makeStyles(() => ({
  signInFormContainer: {},
  paper: {
    boxShadow:
      '0px 0px 3px 1px rgba(0, 0, 0, 0.05), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    margin: '15px 0',
    padding: '25px',
    width: '100%'
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formTitle: {
    fontSize: 20,
    fontWeight: 300,
    textAlign: 'center',
    color: 'rgb(69, 18, 149)'
  },
  modeOption: {
    width: '49%'
  },
  textBlock: {
    color: '#4F4A53',
    fontSize: 22,
    fontWeight: 300,
    textAlign: 'justify'
  },
  fieldContainer: {
    margin: '10px 0'
  },
  forgotPasswordLink: {
    fontSize: '14px',
    color: '#451295',
    textDecoration: 'underline',
    paddingBottom: '15px',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
      color: '#0056b3'
    }
  },
  dontHaveAccountText: {
    fontSize: '20px',
    fontWeight: 300,
    textAlign: 'center',
    color: 'rgb(69, 18, 149)',
    margin: '20px 0 10px 0'
  },
  dialogTitle: {
    color: 'rgb(48, 50, 107)',
    '&:selection': {
      color: 'rgb(255, 255, 255)',
      background: 'rgb(243, 92, 0) none repeat scroll 0% 0%'
    }
  }
}))

export default useSignInStyles
